<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Faltas</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Empleado</a>
        </li>
        <li class="breadcrumb-item active">Faltas</li>
      </ol>
    </div>
    <div class="card">
      <!-- Boton cliente -->
      <div class="card-header">
        <div class="row">
          <div class="col">
            <button
              type="button"
              class="btn btn-theme"
              @click="openModal('add_fault', '')"
            >Agregar falta</button>
          </div>
        </div>
        <!-- Boton activos / inactivos -->
        <br>
        <div class="custom-control custom-checkbox mb-3">
          <input
            id="customControlValidation1"
            v-model="checkboxmanual"
            type="checkbox"
            class="custom-control-input"
            required
            @change="showFaults(1, $route.query.item, checkboxmanual)"
          >
          <label v-if="checkboxmanual === false" class="custom-control-label" for="customControlValidation1">
            Mostrar datos inactivos
          </label>
          <label v-else class="custom-control-label" for="customControlValidation1">
            Mostrar datos activos
          </label>
          <div class="invalid-feedback">Example invalid feedback text</div>
        </div>
      </div>
      <div class="card-body">
        <!-- Nueva tabla -->
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fault in arrayFaults" :key="fault.id">
              <td v-text="fault.description"/>
              <td v-text="showDate(fault.fault_date)"/>
              <td>
                <span v-if="fault.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Anulado</span>
              </td>
              <td>
                <template>
                  <div>
                    <a href/>
                    <button
                      v-tooltip.top-center="'Anular falta'"
                      v-if="fault.state==1"
                      class="btn btn-danger"
                      @click="openModal('desactivate', fault)"
                    >
                      <i class="icon-fa icon-fa-trash" />
                    </button>
                    <button
                      v-tooltip.top-center="'Activar falta'"
                      v-else
                      class="btn btn-info"
                      @click="openModal('activate', fault)"
                    >
                      <i class="icon-fa icon-fa-check" />
                    </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Paginación -->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, checkboxmanual)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- MODALES -->
      <!-- Modal agregar falta -->
      <sweet-modal ref="faults_modal" :title="modalTitle" hide-close-button blocking>
        <div class="row">
          <div class="card-body">
            <div class="form-group">
              <label>Descripción</label>
              <textarea
                :class="{ 'is-invalid': $v.descriptionFault.$error }"
                v-model.trim="descriptionFault"
                class="form-control"
                placeholder="Ingrese la descripción de la falta"
                @textarea="$v.descriptionFault.$touch()"
              />
              <div v-if="$v.descriptionFault.$error">
                <span
                  v-if="!$v.descriptionFault.required"
                  class="help-block help-block-error"
                >El campo es requerido</span>
                <span v-if="!$v.descriptionFault.minLength" class="help-block help-block-error">
                  El minimo del caracteres es de
                  {{ $v.descriptionFault.$params.minLength.min }} letras.
              </span></div>
            </div>
            <div class="form-group">
              <label>Fecha</label>
              <datepicker :class="{ 'is-invalid': $v.fault_date.$error }" :format="customFormatter" v-model.trim="fault_date" :language="es" input-class="form-control" placeholder="Ingrese la fecha de la falta" @input="$v.fault_date.$touch()" />
              <div v-if="$v.fault_date.$error">
                <span
                  v-if="!$v.fault_date.required"
                  class="help-block help-block-error"
                >La fecha de la falta es requerida</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveFault()"
        >Guardar</button>
      </sweet-modal>
      <sweet-modal ref="state_modal" icon="info" hide-close-button blocking>
        {{ modalTitleState }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.state_modal.close()"
        >No</button>
        <button
          v-if="tipoAccion == 2"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="desactivateFault()"
        >Si</button>
        <button
          v-if="tipoAccion == 3"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activateFault()"
        >Si</button>
      </sweet-modal>
    </div>
  </div>
</template>
<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import { es } from 'vuejs-datepicker/dist/locale'
import { required, minLength } from 'vuelidate/lib/validators'
import ladda from 'ladda'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    Datepicker
  },
  data () {
    return {
      es: es,
      arrayFaults: [],
      descriptionFault: '',
      fault_date: null,
      tipoAccion: 1,
      modalTitle: '',
      modalTitleState: '',
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0
      },
      offset: 3,
      item: 'name',
      search: '',
      checkboxmanual: false
    }
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations: {
    fault_date: {
      required
    },
    descriptionFault: {
      required,
      minLength: minLength(5)
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + this.offset * 2
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.showFaults(1, this.$route.query.item, this.checkboxmanual)
  },
  methods: {
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    showDate (date) {
      return moment(date).locale('es').format('LL')
    },
    changePage (page, checkboxmanual) {
      let me = this
      me.pagination.current_page = page
      me.showFaults(page, this.$route.query.item, checkboxmanual)
    },
    // Faltas
    async showFaults (page, id, checkboxmanual) {
      let me = this
      // eslint-disable-next-line no-unused-vars
      const response = await
      // eslint-disable-next-line no-undef
      axios.get(`/api/admin/faults/get?page=${page}&id=${id}&checkboxmanual=${checkboxmanual}`)
        .then(function (response) {
          var respuesta = response.data
          me.arrayFaults = respuesta.faults.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveFault () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.fault_date.$invalid) {
        // eslint-disable-next-line no-undef
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        // eslint-disable-next-line no-undef
        axios
          .post('/api/admin/faults', {
            idemployee: this.$route.query.item,
            description: this.descriptionFault,
            fault_date: this.customFormatter(this.fault_date)
          })
          .then(function (response) {
            // eslint-disable-next-line no-undef
            toastr.success(response.data.message, 'Éxito')
            l.stop()
            me.closeModal()
          })
          .catch(function () {
            l.stop()
            // eslint-disable-next-line no-undef
            toastr.error('Problemas en el servidor', 'Error')
          })
      }
    },
    activateFault () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/faults/activate', {
          id: this.fault_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Falta activada', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    desactivateFault () {
      let me = this
      // eslint-disable-next-line no-undef
      axios
        .put('/api/admin/faults/desactivate', {
          id: this.fault_id
        })
        .then(function (response) {
          // eslint-disable-next-line no-undef
          toastr.success('Falta anulada', 'Éxito')
          me.closeModal()
        })
        .catch(function () {
          // eslint-disable-next-line no-undef
          toastr.error('Problemas en el servidor', 'Error')
        })
    },
    openModal (accion, data = []) {
      this.$v.$reset()
      let me = this
      switch (accion) {
        case 'add_fault': {
          me.$refs.faults_modal.open()
          this.employee_id = this.$route.query.item
          this.descriptionFault = ''
          this.fault_date = ''
          this.tipoAccion = 1
          this.modalTitle = 'Nueva falta'
          break
        }
        case 'desactivate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea anular esta falta?'
          this.fault_id = data['id']
          this.tipoAccion = 2
          break
        }
        case 'activate': {
          me.$refs.state_modal.open()
          this.modalTitleState = '¿Desea activar esta falta?'
          this.fault_id = data['id']
          this.tipoAccion = 3
          break
        }
      }
    },
    closeModal () {
      this.showFaults(this.pagination.current_page, this.$route.query.item, this.checkboxmanual)
      this.$refs.faults_modal.close()
      this.$refs.state_modal.close()
      this.$v.$reset()
      this.employee_id = 0
      this.descriptionFault = ''
      this.fault_id = 0
      this.fault_date = ''
      this.modalTitle = ''
      this.modalTitleState = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/persons/Fault.vue